import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AutoComplete, AutoCompleteCreate } from "@/model";
import autocompleteRepository from "@/repository/autoCompleteRepository";
import { autocompleteQueryKeys } from "./keys";


export const useCreateAutocomplete = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<AutoComplete, AxiosError, AutoCompleteCreate>({
        mutationKey: [agentId, 'autocomplete', 'create'],
        mutationFn: async (body: AutoCompleteCreate) => {
            try {
                const { data } = await autocompleteRepository.create(agentId, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: autocompleteQueryKeys.pageAll(agentId)
            });
        }
    });
};
